module.exports = __webpack_public_path__ + "img/seeking-alpha.be1d7841.png";